module.exports = __webpack_public_path__ + "static/SoteShop-ff968659d0ce362a90836d1125c1efd7.svg";